export enum LocalStorageEnum {
  ACCESS_TOKEN = "AEA-e-commerce-access_token",
  CHECKOUT = "AEA-e-commerce-checkout",
}
